module.exports = __webpack_public_path__ + "img/envio_documentos.66607805.svg";